import ApiService from "./api.service";
import store from "../Store/store";

const MenuService = {
  getItems: async function(page, loc_id) {
    const requestData = {
      method: "post",
      url: `${process.env.VUE_APP_ROOT_API}/getmenu/`,
      data: {
        page,
        loc_id,
      },
    };

    try {
      const response = await ApiService.customRequest(requestData);
      return response.data;
    } catch (error) {
      return error;
    }
  },
};

const SectionService = {
  getItems: async function(loc_id) {
    const requestData = {
      method: "post",
      url: `${process.env.VUE_APP_ROOT_API}/getallsections/`,
      data: {
        loc_id,
      },
    };

    try {
      const response = await ApiService.customRequest(requestData);
      return response.data;
    } catch (error) {
      return error;
    }
  },
};

const ViewProductService = {
  getItems: async function(section, page, loc_id) {
    const requestData = {
      method: "post",
      url: `${process.env.VUE_APP_ROOT_API}/getfocusmenu/`,
      data: {
        page,
        loc_id,
        section,
      },
    };

    try {
      const response = await ApiService.customRequest(requestData);
      return response.data;
    } catch (error) {
      return error;
    }
  },
};

const CategoryList = {
  getItems: async function(page, loc_id) {
    const requestData = {
      method: "post",
      url: `${process.env.VUE_APP_ROOT_API}/getcategories/`,
      data: {
        page,
        loc_id,
      },
    };

    try {
      const response = await ApiService.customRequest(requestData);
      return response.data;
    } catch (error) {
      return error;
    }
  },
};

const SubCategoryList = {
  getItems: async function(page, loc_id) {
    const requestData = {
      method: "post",
      url: `${process.env.VUE_APP_ROOT_API}/getsubcategories/`,
      data: {
        page,
        loc_id,
      },
    };

    try {
      const response = await ApiService.customRequest(requestData);
      return response.data;
    } catch (error) {
      return error;
    }
  },
};

const BannerFeed = {
  getFeed: async function() {
    const requestData = {
      method: "get",
      url: `${process.env.VUE_APP_ROOT_API}/getfeed/`,
    };

    try {
      const response = await ApiService.customRequest(requestData);
      return response.data;
    } catch (error) {
      return error;
    }
  },
};

// const userToken = store.getters.tokenUser;
// alert(userToken)

// const GetItemDetail = {
//   getItems: async function(item_id) {
//     const requestData = {
//       method: "post",
//       url: `${process.env.VUE_APP_ROOT_API}/getitem/`,
//       data: {
//         item_id,
//       },
//     };

//     try {
//       const response = await ApiService.customRequest(requestData);
//       return response.data;
//     } catch (error) {
//       return error;
//     }
//   },
// };

const GetItemDetail = {
    getItems: async function(id, loc_id) {
      const requestData = {
        method: "post",
        url: `https://deus.khaanpin.com/appapi/item/details/`,
        data: {
          id,
          loc_id
        },
      };
  
      try {
        const response = await ApiService.customRequest(requestData);
        return response.data;
      } catch (error) {
        return error;
      }
    },
  };

// const SearchService = {
//   getItems: async function(loc_id, search_term) {
//     // alert(search_term)
//     const requestData = {
//       method: "post",
//       url: `${process.env.VUE_APP_ROOT_API}/searchitem/`,
//       data: {
//         loc_id,
//         search_term,
//       },
//     };

//     try {
//       const response = await ApiService.customRequest(requestData);
//       console.log(response, "search itemmmmmmmmmmmmmmmmmmmmmm");

//       return response.data;
//     } catch (error) {
//       return error;
//     }
//   },
// };

const MegaMenuService = {
  getMenus: async function(loc_id) {
    // alert(loc_id)
    const requestData = {
      method: "post",
      url: `https://deus.khaanpin.com/appapi/menulist/`,
      data: {
        loc_id,
      },
    };

    try {
      const response = await ApiService.customRequest(requestData);
      // console.log(response.data.data, "megamenu from item.service.js");
      return response.data.data;
    } catch (error) {
      return error;
    }
  },
};

const SearchService = {
  getItems: async function(loc_id, search) {
    const requestData = {
      method: "post",
      url: `https://deus.khaanpin.com/appapi/search/`,
      data: {
        loc_id: JSON.stringify(loc_id),
        search,
      },
    };

    try {
      const response = await ApiService.customRequest(requestData);
      // console.log(response, "search itemmmmmmmmmmmmmmmmmmmmmm");
      return response.data;
    } catch (error) {
      return error;
    }
  },
};

// const HomePageListService = {
//   getItems: async function(loc_id) {
//     const requestData = {
//       method: "post",
//       url: `${process.env.VUE_APP_ROOT_API}/gethomepagelists/`,
//       // url: `https://deus.khaanpin.com/appapi/gethomepagelists/`,

//       data: {
//         loc_id,
//       },
//     };

//     try {
//       const response = await ApiService.customRequest(requestData);
//       console.log(response, "hello this response from item services.js")
//       return response.data;
//     } catch (error) {
//       return error;
//     }
//   },
// };

const HomePageListServiceStatic = {
  getItems: async function(loc_id) {
    // const _data = user_id  == null? data : nodata;
    // alert("api call static hom page")
    // alert(user_id);
    const requestData = {
      method: "post",
      url: `https://deus.khaanpin.com/appapi/gethomepagelists/`,
      data: {
        loc_id: JSON.stringify(loc_id),
      },
    };

    try {
      const response = await ApiService.customRequest(requestData);
      // console.log(response.data, "hello this response from item services.js");
      // console.log(response, "static home page list")
      return response.data;
    } catch (error) {
      return error;
    }
  },
};

const HomePageListService = {
  getItems: async function(loc_id, user_id) {
    const withUId = {
      loc_id: JSON.stringify(loc_id),
      // type: "promotional",
      // selling: "top",
      // user_id,
      user_id: JSON.stringify(user_id),
    };

    const withoutUId = {
      loc_id: JSON.stringify(loc_id),
      // type: "promotional",
      // selling: "top",
    };

    if (user_id == null) {
      var DATA = withoutUId;
    } else {
      var DATA = withUId;
    }

    // const _data = user_id  == null? data : nodata;

    // alert(user_id);
    const requestData = {
      method: "post",
      // url: `https://deus.khaanpin.com/appapi/getdynamichomepagelists/`,
      url: `https://deus.khaanpin.com/appapi/getdynamichomepagelists/`,

      data: DATA,
    };

    try {
      const response = await ApiService.customRequest(requestData);
      // console.log(response.data, "hello this response from item services.js");

      let filteredDynamicLists = response.data.data.filter(
        (items) => typeof items.list_items != "string"
      );

      return filteredDynamicLists;
    } catch (error) {
      return error;
    }
  },
};

const GetBannerService = {
  getItems: async function(loc_id, section) {
    const stateLoc = store.getters.currentLocation;
    // console.log(stateLoc, "stateloc from item services");
    const requestData = {
      method: "post",
      url: `${process.env.VUE_APP_ROOT_API}/getbanner/`,
      data: {
        loc_id,

        section,
      },
    };

    try {
      const response = await ApiService.customRequest(requestData);
      return response.data;
    } catch (error) {
      return error;
    }
  },
};

const ListByIdService = {
  getItems: async function(loc_id, list_id, page) {
    const requestData = {
      method: "post",
      url: `${process.env.VUE_APP_ROOT_API}/getlistbyid/`,
      data: {
        loc_id,
        list_id,
        page,
      },
    };

    try {
      const response = await ApiService.customRequest(requestData);
      return response.data;
    } catch (error) {
      return error;
    }
  },
};

const GetPaymentModes = {
  getItems: async function(loc_id) {
    const requestData = {
      method: "post",
      url: `${process.env.VUE_APP_ROOT_API}/getpaymentmodes/`,
      data: {
        loc_id,
      },
    };

    try {
      const response = await ApiService.customRequest(requestData);
      return response.data.data;
    } catch (error) {
      return error;
    }
  },
};

export {
  MenuService,
  BannerFeed,
  CategoryList,
  SubCategoryList,
  ViewProductService,
  SectionService,
  GetItemDetail,
  SearchService,
  HomePageListService,
  HomePageListServiceStatic,
  GetBannerService,
  ListByIdService,
  GetPaymentModes,
  MegaMenuService,
};
